import { format } from 'date-fns';

const columns = [
    {
        field: 'id',
        headerName: 'ID',
        width: 100,
        type: 'number',
        editable: false, // IDs are typically not editable
    },
    {
        field: 'project_name',
        headerName: 'Project Name',
        width: 300,
        editable: true,
    },
    // {
    //     field: 'invoice_id',
    //     headerName: 'Invoice ID',
    //     width: 180,
    //     editable: true,
    // },
    {
        field: 'price',
        headerName: 'Price',
        width: 70,
        type: 'number',
        editable: true,
    },
    {
        field: 'order_type',
        headerName: 'Order Type',
        width: 130,
        editable: true,
    },
    {
        field: 'razorpay_payment_id',
        headerName: 'Razorpay Payment ID',
        width: 220,
        editable: true,
    },
    // {
    //     field: 'razorpay_order_id',
    //     headerName: 'Razorpay Order ID',
    //     width: 220,
    //     editable: true,
    // },
    {
        field: 'file_link',
        headerName: 'File Link',
        width: 250,
        editable: true,
        renderCell: (params) => (
            params.value ? (
                <a href={params.value} className="text-blue-500 underline" target="_blank" rel="noopener noreferrer">
                    View File
                </a>
            ) : (
                <span className="text-gray-500 italic">No Data</span>
            )
        ),
    },
    // {
    //     field: 'slug',
    //     headerName: 'Slug',
    //     width: 180,
    //     editable: true,
    // },
    {
        field: 'email',
        headerName: 'Email',
        width: 250,
        editable: true,
    },
    {
        field: 'name',
        headerName: 'Name',
        width: 180,
        editable: true,
    },
    // {
    //     field: 'phone',
    //     headerName: 'Phone',
    //     width: 150,
    //     editable: true,
    // },
    // {
    //     field: 'user_id',
    //     headerName: 'User ID',
    //     width: 150,
    //     editable: false, 
    // },
    {
        field: 'created_at',
        headerName: 'Created At',
        width: 200,
        type: 'string',
        editable: false,
        valueGetter: (value, row) => {
            return format(new Date(value), 'dd MMM yyyy, hh:mm a');
        }
    },
    // {
    //     field: 'updatedAt',
    //     headerName: 'Updated At',
    //     width: 200,
    //     type: 'string',
    //     editable: false,
    // },
];

export default columns;
